import { HisSearchResultRow } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';



export class UnitDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        eventType: 'sul.common.Course.eventtypeId',
        elementNr: 'sul.common.Unit.elementnr',
        orgunit: 'cs.psv.orgunit.Orgunit',
        title: 'sul.plan.searchLecture.veranstTitle',
        responsibleInstructors: 'cm.exa.eventprocess.responsible_instructor'
    };

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        let text = DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['eventType']));
        if (DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['elementNr'])) {
            text += ' | ' + DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['elementNr']);
        }

        if (DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['orgunit'])) {
            text += ' | ' + DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['orgunit']);
        }
        return text;
    }

    getTitleLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
    }

    getToolTip(row: HisSearchResultRow): string {
        return DetailViewListUtils.assembleToolTip(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['eventType']),
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title), this.hisBaseGlobalsService, this.hisUiService);
    }

    getTitleLink(row: HisSearchResultRow): string {
        return '/pages/startFlow.xhtml?_flowId=detailView-flow&unitId=' + row.get('Unit.id') + '&personIdFromPersonDetailView=' +
            this.person.id + '&navigationPosition=studiesOffered,searchCourses';
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    isExtendable(row: HisSearchResultRow): boolean {
        return false;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        return false;
    }

    getFooterLine(row: HisSearchResultRow): string {
        const responsibleInstructor = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['responsibleInstructors']);
        return responsibleInstructor ?
            `${this.hisUiService.translate('cm.exa.eventprocess.responsible_instructor')}: ${responsibleInstructor}` :
            '';
    }

}
